<div class="level-benefits-container h-100 mt-4 pb-3 ms-auto me-auto">
  <div class="mt-3 level-title">
    <h2 class="pt-4 ms-4">{{ modalTitle() }}</h2>
  </div>
  <div class="body">
    <div class="row mb-3">
      <span label class="mt-3 mb-1 ps-3">Nivel*</span>
      <mat-form-field class="w-100" appearance="outline">
        <mat-select
          id="selectLevel"
          #matSelect
          required
          [(ngModel)]="level"
          [disabled]="isLevelLocked()"
          >
          @for (l of levels; track l) {
            <mat-option [value]="l.id">
              {{ l.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <span label class="mt-1 mb-1 ps-3">Adicional</span>
      <input
        id="additional"
        class="mb-4"
        type="number"
        step="any"
        (keydown)="validateOnlyNumbers($event)"
        (input)="validateTwoDecimals($event)"
        [(ngModel)]="additionals"
        placeholder="Adicional %"
        />
      </div>
      <div class="row">
        <span label class="mt-1 mb-1 ps-3">Beneficio*</span>
        <textarea
          id="textArea"
          [(ngModel)]="description"
          placeholder="Beneficio"
          class="mb-4"
          cols="30"
          maxlength="250"
          rows="12"
          required
        ></textarea>
      </div>
    </div>
    <div class="row buttons-footer justify-content-end buttons-level">
      <button id="cancelButton" class="ind-button-lite" (click)="cancelClick()">
        <span class="text-buttons ms-0">Cancelar</span>
      </button>

      <button id="saveButton" class="ind-button" (click)="onSubmit()">
        <span class="text-buttons ms-0">Guardar</span>
      </button>
    </div>
  </div>
